import React, { Component } from 'react';
import PropTypes from 'prop-types';
import hljs from 'highlight.js';
import { CuiPanel } from '../panel';

const typeToLabelMap = {
  css: 'CSS',
  html: 'HTML',
  javascript: 'JavaScript',
};

export const TYPES = Object.keys(typeToLabelMap);

export class CuiCodeSnippet extends Component {
  componentDidMount() {
    this.update();
  }

  shouldComponentUpdate(nextProps) {
    return nextProps !== this.props;
  }

  componentDidUpdate() {
    this.update();
  }

  codeRef = c => {
    this.highlightableCode = c;
  };

  update() {
    hljs.highlightBlock(this.highlightableCode);
  }

  render() {
    const { className, code, type, ...rest } = this.props;
    const label = typeToLabelMap[type];

    return (
      <CuiPanel className={className} {...rest}>
        <div className="cuiCodeSnippet__label">{label}</div>
        <div className="cuiCodeSnippet__content">
          <div className="cuiCodeSnippet__codeWrapper">
            <pre className="cuiCodeSnippet__pre">
              <code ref={this.codeRef} className={`language-${type}`}>
                {code}
              </code>
            </pre>
          </div>
        </div>
      </CuiPanel>
    );
  }
}

CuiCodeSnippet.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(TYPES).isRequired,
  code: PropTypes.string,
};

CuiCodeSnippet.defaultProps = {
  className: undefined,
  code: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/codeSnippet/CodeSnippet.js